/*
 *  TTTech nerve-management-system-frontend
 *  Copyright(c) 2026. TTTech Industrial Automation AG.
 *
 *  ALL RIGHTS RESERVED.
 *
 *  Usage of this software, including source code, netlists, documentation,
 *  is subject to restrictions and conditions of the applicable license
 *  agreement with TTTech Industrial Automation AG or its affiliates.
 *
 *  All trademarks used are the property of their respective owners.
 *
 *  TTTech Industrial Automation AG and its affiliates do not assume any liability
 *  arising out of the application or use of any product described or shown
 *  herein. TTTech Industrial Automation AG and its affiliates reserve the right to
 *  make changes, at any time, in order to improve reliability, function or
 *  design.
 *
 *  Contact Information:
 *  support@tttech-industrial.com
 *
 *  TTTech Industrial Automation AG, Schoenbrunnerstrasse 7, 1040 Vienna, Austria
 *
 */
import { defineStore } from 'pinia';
import { CampaignAndTasksApiService } from '@/services/api';
import CampaignModel from '@/model/campaign-and-tasks/campaign.model';

const useNodeUpdateLogStore = defineStore('nodeUpdateLog', {
  state: () => ({
    nodeUpdateLogList: [],
    totalLogs: 0,
  }),

  actions: {
    async fetchNodeUpdateCampaigns(data) {
      const params = {
        limit: data.itemsPerPage || 10,
        page: data.page || 1,
        ...(data.search && { filterBy: { searchText: data.search || '' } }),
        contentType: 'node_update',
      };
      const { list: campaigns, count } = await CampaignAndTasksApiService.fetchCampaigns({ params });
      // using $patch
      this.$patch({
        nodeUpdateLogList: campaigns.map((campaign) => new CampaignModel(campaign)),
        totalLogs: count,
      });
    },
    async deleteNodeUpdateLog(id) {
      await CampaignAndTasksApiService.deleteCampaign(id);
      this.nodeUpdateLogList.splice(
        this.nodeUpdateLogList.findIndex((log) => log.id === id),
        1,
      );
    },

    handleBomServiceUpdateEvents(payload) {
      const campaignType = payload.params?.campaignType;
      if (campaignType !== 'node_update') {
        return;
      }
      if (payload.name === 'all-admins-bom-campaign-created') {
        const newCampaign = new CampaignModel(payload.params);
        this.nodeUpdateLogList.unshift(newCampaign);
      }
      if (payload.name === 'all-admins-bom-campaign-updated-finished') {
        const campaignId = payload.params?.id;
        if (!campaignId) {
          return;
        }
        const campaignToUpdate = this.nodeUpdateLogList.find((log) => log.id === campaignId);
        if (!campaignToUpdate) {
          return;
        }
        const data = payload.params;
        // mark campaign as finished
        campaignToUpdate.progress = CampaignModel.formatProgress(data.progress);
        campaignToUpdate.status = CampaignModel.formatStatus(data.status);
        campaignToUpdate.finished = CampaignModel.formatDate(data.timeOfOperationFinish);
      }
      if (payload.name === 'all-admins-bom-campaign-updated') {
        const campaignId = payload.params?.id;
        if (!campaignId) {
          return;
        }
        const campaignToUpdate = this.nodeUpdateLogList.find((log) => log.id === campaignId);
        if (!campaignToUpdate) {
          return;
        }
        const data = payload.params;
        // update campaign details
        campaignToUpdate.progress = CampaignModel.formatProgress(data.progress);
        campaignToUpdate.status = CampaignModel.formatStatus(data.status);
        campaignToUpdate.finished = CampaignModel.formatDate(data.timeOfOperationFinish);
      }
    },
  },
});

export default useNodeUpdateLogStore;
